export default __webpack_public_path__ + "static/media/avatar.b310ebaf.webp";